export const jump_middle_page = (v_param) => {
    var config = {
        //获取微信code
        LOGIN_ROUTE : "https://www.kuaikanmanhua.com/v1/passport/login/pc/login_route_code?from=h5&oauth_provider=wechat&code_only=true&need_auth=false&redirect_url=",
        local : {
            MIDDLE_URL : "http://"+location.hostname+":8080/webapp/pay/test_redirectpay_middlepage.html?eruda=true&",
            RESULT_URL : "http://"+location.hostname+":8080/webapp/pay/test_redirectpay_resultpage.html?eruda=true&",
        },
        dev : {
            MIDDLE_URL  : "https://dev-www.quickcan.cn/webapp/pay/test_redirectpay_middlepage.html?eruda=true&",
            RESULT_URL  : "https://dev-www.quickcan.cn/webapp/pay/test_redirectpay_resultpage.html?eruda=true&",
        },
        stag : {
            MIDDLE_URL  : "https://www.quickcan.cn/webapp/pay/test_redirectpay_middlepage.html?eruda=true&",
            RESULT_URL  : "https://www.quickcan.cn/webapp/pay/test_redirectpay_resultpage.html?eruda=true&",
        },
        prodtest : {
            MIDDLE_URL  : "https://www.kuaikanmanhua.com/webapp/pay/test_redirectpay_middlepage.html?eruda=true&",
            RESULT_URL  : "https://www.kuaikanmanhua.com/webapp/pay/test_redirectpay_resultpage.html?eruda=true&",
        },
        prod : {
            MIDDLE_URL  : "https://www.kuaikanmanhua.com/webapp/pay/redirectpay_middlepage.html?",
            RESULT_URL  : "https://www.kuaikanmanhua.com/webapp/pay/redirectpay_resultpage.html?",
        },
    };
    var userAgent = navigator.userAgent.toLowerCase();
    var is_iphone_qqnative = (/(iphone|ipod|ipad)/i.test(userAgent) && / QQ/i.test(navigator.userAgent));
    var is_android_qqnative = (/android/.test(userAgent) && /\sQQ/i.test(navigator.userAgent) && /QQ/i.test((navigator.userAgent).split("MQQBrowser")));
    var ua = {
        local   : /\S/.test(location.port),
        dev     : /\.cn/.test(location.host) && /dev-/.test(location.host),
        stag    : /\.cn/.test(location.host) && !/dev-/.test(location.host),
        prod    : /\.com/.test(location.host),
        weixin  : /micromessenger/.test(userAgent),
        qqnative: (is_android_qqnative || is_iphone_qqnative),
    };
    var key = "prod";
    var istest = /env=s/.test(location.href);
    if (!ua.prod) {
        key = ua.local ? "prodtest" : ua.dev ? "dev" : ua.stag ? "stag" : "prod";
    }
    if (ua.prod && istest) {
        key = "prodtest";
    }

    var middle_url = config[key].MIDDLE_URL;
    var result_url = config[key].RESULT_URL;
    if (ua.weixin || ua.qqnative) {
        if (!ua.prod) {
            middle_url = config["prodtest"].MIDDLE_URL;    
        } 
    }

    //微信本地调试-8080端口中间页的时候
    var localwxtest = false;
    if (localwxtest) {
        middle_url = config["local"].MIDDLE_URL;
    }
    //
    v_param.result_url = result_url;
    middle_url += "v_param="+encodeURIComponent(JSON.stringify(v_param))+"&t="+new Date().getTime();
    var jumptourl = middle_url;
    if (ua.weixin) {
        jumptourl = config.LOGIN_ROUTE+encodeURIComponent(middle_url);
    }
    //测试环境在微信/qqnative场景需要经过线上域名，因此需要加入setck中间页 ||
    //local地址走测试-还需要启动8080端口，为了省去此操作，也跑线上域名
    if (ua.weixin || ua.qqnative || ua.local) {
        if(key !== "prod") {
            var name = "passToken";
            var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
            var arr = document.cookie.match(reg);
            var passToken = decodeURIComponent(arr[2]) || "";
            jumptourl = "https://www.kuaikanmanhua.com/webapp/login/setck.html?passToken="+passToken+"&redirect_uri="+encodeURIComponent(jumptourl);
        }
    }
    location.replace(jumptourl);
};






// WEBPACK FOOTER //
// ./src/components/web/pay/js/utils.js